<template>
  <div id="BiddingItemsComponent" class="layout-bidding-item">
    <v-card outlined
      ><v-card-title>Bidding Items </v-card-title>
      <v-card-text>
        <v-tabs v-model="isTabs">
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="(item, index) in projectDetail" :key="index">
            {{
              index === 0
                ? "First Submit"
                : `Negotiation #${item.biddingRound - 1}`
            }}
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="isTabs">
          <v-tab-item
            v-for="(bidItem, bidindex) in projectDetail"
            :key="bidindex"
          >
            <v-card flat>
              <v-card-text>
                <v-row align="center" class="pa-4">
                  <v-col cols="3">
                    <v-select
                      :disabled="!checkEdit(bidItem.biddingRound, isEdit)"
                      outlined
                      dense
                      v-model="bidItem.itemCurrency"
                      :items="dataExchangeRate"
                      :rules="[(v) => !!v || 'Currency is required']"
                      label="Currency for bidding"
                      required
                      :item-text="'exchange'"
                      return-object
                    >
                    </v-select></v-col
                  ><v-divider
                    v-if="
                      bidindex === projectDetail.length - 1 &&
                      checkEdit(bidItem.biddingRound, isEdit)
                        ? bidItem.biddingRound === isRound
                        : false
                    "
                    class="mx-4"
                    vertical
                  ></v-divider
                  ><v-col
                    cols="8"
                    class="mt-n6 mb-4"
                    v-if="
                      bidindex === projectDetail.length - 1 &&
                      checkEdit(bidItem.biddingRound, isEdit)
                        ? bidItem.biddingRound === isRound
                        : false
                    "
                  >
                    <p class="mb-2">
                      If you want to multiple import price, Please click button
                      below.
                    </p>
                    <v-dialog v-model="popupImportPrice" width="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark v-bind="attrs" v-on="on">
                          <v-icon dark left> mdi-table-edit </v-icon> Edit in
                          Excel
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="grey lighten-2">
                          Multiple Import Price
                        </v-card-title>
                        <v-card-text>
                          <p class="mt-4">
                            1. Export excel template and fill in multiple price.
                          </p>
                          <v-btn
                            color="primary"
                            dark
                            outlined
                            @click="exportToExcel(bidItem.item)"
                          >
                            <v-icon dark left> mdi-export-variant </v-icon>
                            Export
                          </v-btn>
                          <p class="mt-4">
                            2. Import excel template from step 1.
                          </p>
                          <v-file-input
                            label="File input"
                            v-model="fileBulkTemplateImportPrice"
                            outlined
                            dense
                            show-size
                            accept=".xlsx"
                            :rules="[(v) => !!v || 'File input is required']"
                            required
                          ></v-file-input>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            :disabled="!fileBulkTemplateImportPrice"
                            @click.stop="importPrice"
                          >
                            Submit
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="popupImportPrice = !popupImportPrice"
                          >
                            Cancel
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog> </v-col
                  ><v-col cols="12"
                    ><p class="red--text">
                      * บริษัทขอสงวนสิทธิ์ในการสั่งซื้อสินค้าบางรายการ
                    </p>
                    <p class="red--text mt-n4">
                      * กรณีสั่งซื้อสินค้า
                      ผู้เสนอราคาสามารถเสนอราคาเฉพาะสินค้าบางรายการ
                      หรือทั้งหมดได้
                    </p></v-col
                  >
                  <!-- <v-col cols="3" class="ml-auto">
                     
                    </v-col> -->
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title>
                        <v-col
                          cols="auto"
                          v-if="bidItem.biddingRound > 1"
                          class="d-flex align-center"
                        >
                          <v-checkbox
                            v-model="showBiddableOnly"
                            label="Show only the items that had bids in the previous round"
                            hide-details
                            dense
                            class="mt-0"
                          ></v-checkbox>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="3"
                          ><v-text-field
                            outlined
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            dense
                          ></v-text-field
                        ></v-col>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-data-table
                        :headers="headers"
                        :items="getFilteredItems(bidItem)"
                        :search="search"
                        hide-default-header
                        :loading="loadingTable"
                        @update:options="onPaginationChange"
                      >
                        <template slot="header" :headers="headers">
                          <thead class="v-data-table-header">
                            <tr>
                              <th v-for="header in headers" :key="header.value">
                                {{ header.text }}
                                <v-chip
                                  v-if="header.value === 'offerUnitPrice'"
                                  outlined
                                  small
                                  color="red"
                                >
                                  Ex. VAT
                                </v-chip>
                              </th>
                            </tr>
                          </thead>
                        </template>
                        <template
                          v-slot:[`item.offerUnitPrice`]="{ item }"
                          v-if="!checkEdit(bidItem.biddingRound, isEdit)"
                        >
                          {{
                            bidItem.biddingRound === 1
                              ? item.offerUnitPrice
                              : item[
                                  `offerUnitPriceRound${bidItem.biddingRound}`
                                ]
                          }}
                        </template>
                        <template
                          v-else
                          v-slot:[`item.offerUnitPrice`]="{ item }"
                        >
                          <v-text-field
                            ref="input"
                            :disabled="!checkEdit(bidItem.biddingRound, isEdit)"
                            v-if="bidItem.biddingRound === 1"
                            outlined
                            dense
                            v-model="item.offerUnitPrice"
                            :rules="[
                              (v) => !!v || v === 0 || 'Unit Price is required',
                              (v) => {
                                const decimalPlaces =
                                  v.toString().split('.')[1]?.length || 0;
                                return (
                                  decimalPlaces <= 2 ||
                                  'ทศนิยมไม่เกิน 2 ตำแหน่ง'
                                );
                              },
                              (v) => v >= 0 || 'ราคาไม่สามารถเป็นค่าติดลบ',
                            ]"
                            required
                            min="0"
                            type="text"
                            class="mt-4"
                            @input="
                              (v) => {
                                let num = v.replace(/([^0-9.]|(?<=\.[^.]*)\.)/g, '').replace(/^0*/g, '').replace(/^\./g, '0.');
                                num = num === '' ? '0' : num;
                                editItemPrice(num, item, `offerUnitPrice`);
                              }
                            "
                            @blur="
                              () => {
                                let num = parseFloat(item.offerUnitPrice);
                                num = isNaN(num) ? '0' : num.toFixed(2);
                                item.offerUnitPrice = num + 1;
                                editItemPrice(num, item, `offerUnitPrice`);
                              }
                            "
                          ></v-text-field>
                          <v-text-field
                            ref="input"
                            v-else
                            class="mt-4"
                            :disabled="
                              !checkEdit(bidItem.biddingRound, isEdit) ||
                              (bidItem.biddingRound > 1 &&
                                (bidItem.biddingRound === 2 ? item.offerUnitPrice === 0 :
                                item[`offerUnitPriceRound${bidItem.biddingRound - 1}`] === 0)
                              )
                            "
                            outlined
                            dense
                            v-model="item[`offerUnitPriceRound${bidItem.biddingRound}`]"
                            :rules="[
                              (v) => !!v || v === 0 || 'Unit Price is required',
                              (v) => {
                                const round = bidItem.biddingRound;
                                if (round > 1) {
                                  const previousRoundPrice =
                                    round === 2
                                      ? item.offerUnitPrice
                                      : item[`offerUnitPriceRound${round - 1}`];
                                  return (
                                    v <= previousRoundPrice ||
                                    'ต้องไม่เสนอราคามากกว่ารอบก่อน'
                                  );
                                }
                                return true;
                              },
                              (v) => {
                                const decimalPlaces =
                                  v.toString().split('.')[1]?.length || 0;
                                return (
                                  decimalPlaces <= 2 ||
                                  'ทศนิยมไม่เกิน 2 ตำแหน่ง'
                                );
                              },
                              (v) => v >= 0 || 'ราคาไม่สามารถเป็นค่าติดลบ',
                            ]"
                            required
                            type="text"
                            min="0"
                            @input="
                              (v) => {
                                let num = v.replace(/([^0-9.]|(?<=\.[^.]*)\.)/g, '').replace(/^0*/g, '').replace(/^\./g, '0.');
                                num = num === '' ? '0' : num;
                                editItemPrice(num, item, `offerUnitPriceRound${bidItem.biddingRound}`);
                              }
                            "
                            @blur="
                              () => {
                                let num = parseFloat(item[`offerUnitPriceRound${bidItem.biddingRound}`]);
                                num = isNaN(num) ? '0' : num.toFixed(2);
                                // set value to num + 1 for force vue re-render before set to num (real value) after
                                item[`offerUnitPriceRound${bidItem.biddingRound}`] = num + 1;
                                editItemPrice(num, item, `offerUnitPriceRound${bidItem.biddingRound}`);
                              }
                            "
                          ></v-text-field>
                        </template>
                        <template v-slot:[`item.isNoOffer`]="{ item }">
                          <v-checkbox
                            disabled
                            v-if="bidItem.biddingRound === 1"
                            v-model="item.isNoOffer"
                            >{{ item.isNoOffer }}</v-checkbox
                          >
                          <v-checkbox
                            v-else
                            disabled
                            v-model="
                              item[`isNoOfferRound${bidItem.biddingRound}`]
                            "
                            >{{
                              item[`isNoOfferRound${bidItem.biddingRound}`]
                            }}</v-checkbox
                          >
                        </template>
                        <template v-slot:[`item.offerTotalAmount`]="{ item }">
                          {{
                            bidItem.biddingRound === 1
                              ? srtingToNumber(
                                  setTotal(item.offerUnitPrice, item)
                                )
                              : srtingToNumber(
                                  setTotal(
                                    item[
                                      `offerUnitPriceRound${bidItem.biddingRound}`
                                    ],
                                    item
                                  )
                                )
                          }}
                        </template>
                        <template
                          v-slot:[`item.remarkNoOffer`]="{ item }"
                          v-if="!checkEdit(bidItem.biddingRound, isEdit)"
                        >
                          {{
                            bidItem.biddingRound === 1
                              ? item.remarkNoOffer
                              : item[
                                  `remarkNoOfferRound${bidItem.biddingRound}`
                                ]
                          }}
                        </template>
                        <template
                          v-slot:[`item.remarkNoOffer`]="{ item }"
                          v-else
                        >
                          <v-text-field
                            class="mt-4"
                            :disabled="!checkEdit(bidItem.biddingRound, isEdit)"
                            v-if="bidItem.biddingRound === 1"
                            outlined
                            dense
                            v-model="item.remarkNoOffer"
                          ></v-text-field>
                          <v-text-field
                            v-else
                            class="mt-4"
                            :disabled="!checkEdit(bidItem.biddingRound, isEdit)"
                            outlined
                            dense
                            v-model="
                              item[`remarkNoOfferRound${bidItem.biddingRound}`]
                            "
                          ></v-text-field>
                        </template>
                        <template v-slot:[`body.append`]>
                          <tr>
                            <td style="text-align: end" colspan="7">
                              Grand Total
                            </td>
                            <td>
                              {{
                                srtingToNumber(
                                  calGrandTotal(
                                    bidItem.item,
                                    bidItem.biddingRound
                                  )
                                )
                              }}
                            </td>
                            <td></td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card> </v-col
                  ><v-col cols="12" class="mt-8"
                    ><p class="text--primary subtitle-2">
                      Estimated total price in THB :
                      {{ bidItem.itemCurrency.rate }}
                    </p>
                    <h2 v-if="bidItem.biddingRound === 1">
                      {{ totalAmount === null ? 0 : numberBaht(totalAmount) }}
                    </h2>
                    <h2 v-if="bidItem.biddingRound === 2">
                      {{
                        totalAmountRound2 === null
                          ? 0
                          : numberBaht(totalAmountRound2)
                      }}
                    </h2>
                    <h2 v-if="bidItem.biddingRound === 3">
                      {{
                        totalAmountRound3 === null
                          ? 0
                          : numberBaht(totalAmountRound3)
                      }}
                    </h2>
                    <h2 v-if="bidItem.biddingRound === 4">
                      {{
                        totalAmountRound4 === null
                          ? 0
                          : numberBaht(totalAmountRound4)
                      }}
                    </h2>
                    <h2 v-if="bidItem.biddingRound === 5">
                      {{
                        totalAmountRound5 === null
                          ? 0
                          : numberBaht(totalAmountRound5)
                      }}
                    </h2>
                    <h2 v-if="bidItem.biddingRound === 6">
                      {{
                        totalAmountRound6 === null
                          ? 0
                          : numberBaht(totalAmountRound6)
                      }}
                    </h2></v-col
                  ></v-row
                ></v-card-text
              >
            </v-card>
          </v-tab-item>
        </v-tabs-items></v-card-text
      ></v-card
    >
    <BiddingDetailComponent
      class="mt-6"
      @emitBiddingDetail="callBackBiddingDetail"
      @callbackIsTab="callBackTabs"
      @emitValidateDetail="callBackValidateDetail"
      :propBiddingDetail="dataBiddingDetailSub"
      :propIsVendorValid="propIsVendorValid"
      :propIsEdit="isEdit"
      :propIsloadDetail="callDetail"
      :propCheckStep="propCheckStep"
      :propsIsTabs="isTabs"
    />
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";
import { masterservice } from "../../../services/masterservice";
import { numberFormat } from "../../../services/utility";
import BiddingDetailComponent from "./BiddingDetail";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const currencyMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: true,
});
export default {
  name: "",
  props: {
    propIsEdit: {
      type: Boolean,
      default: () => false,
    },
    propIsVendorValid: {
      type: Boolean,
      default: false,
    },
    propDataBiddingModelBack: {
      type: Boolean,
      default: () => false,
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
  },
  components: {
    BiddingDetailComponent,
  },
  data: () => ({
    currencyMask,
    validFileExcel: true,
    search: "",
    projectDetail: {},
    dataExchangeRate: [],
    selectedCurrency: {
      exchId: 0,
      exchange: "",
      rate: 0,
      exchDate: "",
    },
    dataBiddingItem: [],
    dataBiddingDetail: {},
    dataBiddingDetailSub: [],

    totalAmount: 0,
    totalAmountRound2: 0,
    totalAmountRound3: 0,
    totalAmountRound4: 0,
    totalAmountRound5: 0,
    totalAmountRound6: 0,

    GrandTotal: 0,
    isRound: 0,
    isEdit: false,
    callDetail: false,
    isTabs: 0,

    popupImportPrice: false,

    // Export Excel
    selectedFormat: "xlsx",
    excelFileName: "",
    cellAutoWidth: true,
    headerTitle: [
      "Company (Don't Edit)",
      "Product / Service Name (Don't Edit)",
      "Spec (Don't Edit)",
      "Quantity (Don't Edit)",
      "Unit of Measure (Don't Edit)",
      "Unit Price (Can Edit)",
      // "isNoOffer",
      "Remark (Can Edit)",
    ],
    headerVal: [
      "companyFullName",
      "shortDescription",
      "longDescription",
      "quantity",
      "unitOfMeasureName",
      "offerUnitPrice",
      // "isNoOffer",
      "remarkNoOffer",
    ],
    dataExcel: {
      offerUnitPrice: 0,
      remarkNoOffer: "",
    },
    valid: true,
    validDetail: false,
    headers: [
      { text: "Company", value: "companyFullName", sortable: false },
      {
        text: "Product / Service Name",
        value: "shortDescription",
        sortable: false,
      },
      { text: "Spec", value: "longDescription", sortable: false },
      { text: "Quantity", value: "quantity", sortable: false },
      { text: "Unit of Measure", value: "unitOfMeasureName", sortable: false },
      { text: "Unit Price", value: "offerUnitPrice", sortable: false },
      { text: "Contract Period (Month)", value: "itemPeriod", sortable: false },
      { text: "Total Amount", value: "offerTotalAmount", sortable: false },
      { text: "Offer", value: "isNoOffer", sortable: false },
      { text: "Remark", value: "remarkNoOffer", sortable: false },
    ],
    fileBulkTemplateImportPrice: null,
    showBiddableOnly: false,
    loadingTable: false,
    pagination: {
      page: 1,
      itemsPerPage: 10, // ค่าเริ่มต้น
    },
    currentPage: {
      page: 1,
      itemsPerPage: 10, // ค่าเริ่มต้น
    },
  }),
  computed: {
    vendorId() {
      return this.$store.state.AppActiveUser.vendorID;
    },
  },
  mounted() {
    this.isEdit = this.propIsEdit;
    this.$loading(true);
    this.loadingTable = true;
    Promise.all([
      this.getProjectBiddingSubmit(),
      this.calculateTotalAmount(),
    ]).then(() => {
      this.$loading(false);
      this.loadingTable = false;
    });
  },
  methods: {
    async validate() {
      const index = this.projectDetail.length - 1;
      if (await this.checkEdit(this.isRound, this.isEdit)) {
        const round = this.isRound;
        const items = this.projectDetail[index].item;
        for (const item of items) {
          const properties = [
            "offerUnitPrice",
            "offerUnitPriceRound2",
            "offerUnitPriceRound3",
            "offerUnitPriceRound4",
            "offerUnitPriceRound5",
            "offerUnitPriceRound6",
          ];
          if (round > 1) {
            const currentRoundPrice = item[`offerUnitPriceRound${round}`];
            const previousRoundPrice =
              round === 2
                ? item.offerUnitPrice
                : item[`offerUnitPriceRound${round - 1}`];

            if (currentRoundPrice > previousRoundPrice) {
              this.$notify({
                type: "error",
                title: "Validation Error",
                text: "New round price must be lower than previous round price",
              });
              this.isSaveDraft = false;
              this.$loading(false);
              return;
            }
          }
          for (const prop of properties) {
            if (item[prop] !== null) {
              if (item[prop] < 0) {
                this.$notify({
                  type: "error",
                  title: "Validation Error",
                  text: "Unit price cannot be negative",
                });
                this.isSaveDraft = false;
                this.$loading(false);
                return;
              }
              const decimalPlaces =
                item[prop].toString().split(".")[1]?.length || 0;
              if (decimalPlaces > 2) {
                this.$notify({
                  type: "error",
                  title: "Validation Error",
                  text: "Unit price cannot have more than 2 decimal places",
                });
                this.valid = false;
                return;
              }
            }
          }
        }
        if (!this.projectDetail[index].itemCurrency.exchId) {
          this.$notify({
            type: "error",
            title: "Save Bidding Items Failed.",
            text: `Please select currency for bidding.`,
          });
          this.valid = false;
        } else {
          this.valid = true;
          this.$loading(true);

          setTimeout(() => {
            if (this.valid && this.validDetail) {
              this.$emit("emitSubmitBiddingStep2Next");
            }
            this.$loading(false);
          }, 1000);
        }
      } else {
        this.$emit("emitSubmitBiddingStep2Next");
      }
    },
    onPaginationChange(newOptions) {
      this.currentPage = newOptions;
    },
    getFilteredItems(bidItem) {
      if (!this.showBiddableOnly || bidItem.biddingRound <= 1) {
        return bidItem.item;
      }
      const prevRoundIndex = bidItem.biddingRound - 2;
      const prevItems = this.projectDetail[prevRoundIndex]?.item || [];
      return bidItem.item.filter((item, idx) => {
        const prevItem = prevItems[idx];
        if (!prevItem) return true;
        if (bidItem.biddingRound === 2) {
          return prevItem.offerUnitPrice !== 0 && prevItem.offerUnitPrice !== null;
        } else {
          const prevPrice = prevItem[`offerUnitPriceRound${bidItem.biddingRound - 1}`];
          return prevPrice !== 0 && prevPrice !== null;
        }
      });
    },
    checkEdit(isRound, isEdit) {
      const round = this.isRound === isRound ? true : false;
      if (round && isEdit) return true;
      else return false;
    },
    async setDataForGetProject(result) {
      for (let i = 0; i < result.length; i++) {
        if (result[i].currencyId === null) {
          result[i].itemCurrency = this.selectedCurrency;
          this.getExchangeRate(null);
        } else {
          const item = await this.getExchangeRate(result[i].currencyId);
          result[i].itemCurrency = item;
        }
      }
      return result;
    },
    async getProjectBiddingSubmit() {
      const result =
        await _projectservice.GetBiddingProjectVendorSubmitItemNegotiate(
          this.$route.params.projectId,
          this.vendorId
        );

      const round = result.length;
      if (round <= 1 || round === undefined) {
        let resultOldDetail = await _projectservice.GetBiddingDetail(
          this.$route.params.projectId,
          this.vendorId
        );
        // Handle vendor walk-in
        if (resultOldDetail.length == 0) {
          resultOldDetail = await _projectservice.GetPublicBiddingDetail(
            this.$route.params.projectId
          );
        }

        const resultOldItem = await _projectservice.GetBiddingProjectItem(
          this.$route.params.projectId,
          this.vendorId
        );

        let biddingProject = resultOldDetail;
        biddingProject[0].item = resultOldItem;
        const returnSetData = await this.setDataForGetProject(biddingProject);
        this.projectDetail = returnSetData;
        this.projectDetail[0].biddingRound = 1;
        this.dataBiddingDetailSub = this.setdataBiddingDetial(
          this.projectDetail
        );

        this.isRound = resultOldDetail[resultOldDetail.length - 1].biddingRound;
        this.callDetail = true;
      } else {
        const returnSetData = await this.setDataForGetProject(result);
        this.projectDetail = returnSetData;
        this.dataBiddingDetailSub = this.setdataBiddingDetial(returnSetData);
        this.isRound = returnSetData[returnSetData.length - 1].biddingRound;
        this.callDetail = true;
      }
    },
    setdataBiddingDetial(data) {
      let result = [];
      for (let i = 0; i < data.length; i++) {
        const element = {
          deliveryTime: data[i].deliveryTime,
          incoTerm: data[i].incoTerm,
          paymentTerm: data[i].paymentTerm,
          warranty: data[i].warranty,
          deviation: data[i].deviation,
          additionalInformation: data[i].additionalInformation,
          biddingRound: data[i].biddingRound,
          priceValid: data[i].priceValid,
          deliveryDate: data[i].deliveryDate,
        };
        result.push(element);
      }
      return result;
    },

    async getExchangeRate(id) {
      this.dataExchangeRate = await masterservice.GetMasterExchangeRate(
        parseInt(this.$route.params.projectId)
      );
      if (id !== null)
        return Promise.all([this.getCurrencyForEdit(id)]).then(
          (result) => result[0]
        );
    },
    getCurrencyForEdit(id) {
      let object = this.dataExchangeRate.find((item) => item.exchId === id);
      this.selectedCurrency = object;
      return object;
    },
    callBackTabs(value) {
      this.isTabs = value;
    },
    calGrandTotal(dataPrice, round) {
      return round <= 1
        ? dataPrice.reduce(
            (acc, item) => acc + item.offerUnitPrice * item.quantity,
            0
          )
        : dataPrice.reduce(
            (acc, item) =>
              acc + item[`offerUnitPriceRound${round}`] * item.quantity,
            0
          );
    },
    number(number) {
      if (number != null) return numberFormat(number);
    },
    numberBaht(number) {
      if (number != null)
        return number.toLocaleString("th-TH", {
          style: "currency",
          currency: "THB",
        });
    },
    srtingToNumber(number) {
      if (number != null)
        return number.toLocaleString({
          style: "currency",
          currency: "THB",
        });
    },
    callBackBiddingDetail(biddingDetail) {
      this.dataBiddingDetailSub = biddingDetail;
      this.setSubmitBiddingItemModel();
    },
    setSubmitBiddingItemModel() {
      const round = this.projectDetail.length - 1;
      if (this.projectDetail[round] !== undefined) {
        const items = this.formatData(
          this.projectDetail[round].item,
          this.projectDetail[round].biddingRound
        );

        const dataSubmitBiddingItemModel = {
          projectId: parseInt(this.$route.params.projectId),
          vendorId: this.$store.state.AppActiveUser.vendorID,
          biddingStatus: "",
          biddingRound: this.projectDetail[round].biddingRound,
          offerGrandTotalAmount:
            this.isRound === 1
              ? this.totalAmount
              : this.isRound === 2
              ? this.totalAmountRound2
              : this.isRound === 3
              ? this.totalAmountRound3
              : this.isRound === 4
              ? this.totalAmountRound4
              : this.totalAmountRound5,

          deliveryTime: +this.dataBiddingDetailSub[round].deliveryTime,
          incoTerm: this.dataBiddingDetailSub[round].incoTerm,
          paymentTerm: +this.dataBiddingDetailSub[round].paymentTerm,
          warranty: +this.dataBiddingDetailSub[round].warranty,
          deviation: this.dataBiddingDetailSub[round].deviation,
          priceValid: +this.dataBiddingDetailSub[round].priceValid,

          deliveryDate: this.dataBiddingDetailSub[round].deliveryDate,
          additionalInformation:
            this.dataBiddingDetailSub[round].additionalInformation,
          currencyId: this.projectDetail[round].itemCurrency.exchId,
          item: items,
        };

        this.projectDetail[round].currencyId =
          this.projectDetail[round].itemCurrency.exchId;

        this.$emit("emitSubmitBiddingModel", dataSubmitBiddingItemModel);
      }
    },
    isEmpty(obj) {
      for (var key in obj) {
        /* eslint no-prototype-builtins: "error" */
        if (Object.prototype.hasOwnProperty.call(key)) return false;
      }
      return true;
    },
    setTotal(price, item) {
      price = price !== null ? price : 0;
      const quantity = item.quantity !== null ? item.quantity : 0;
      return price * quantity;
    },
    formatData(items, round) {
      for (let i = 0; i < items.length; i++) {
        if (this.isRound === 1) {
          if (
            items[i].offerUnitPrice !== null &&
            items[i].offerUnitPrice !== 0
          ) {
            items[i].offerUnitPrice = Number(items[i].offerUnitPrice);
            items[i].isNoOffer = true;
          } else {
            items[i].offerUnitPrice = 0;
            items[i].isNoOffer = false;
          }
          items[i].remarkNoOffer =
            items[i].remarkNoOffer === null ? "" : items[i].remarkNoOffer;
        } else {
          if (
            items[i][`offerUnitPriceRound${round}`] !== null &&
            items[i][`offerUnitPriceRound${round}`] !== 0
          ) {
            items[i][`offerUnitPriceRound${round}`] = Number(
              items[i][`offerUnitPriceRound${round}`]
            );
            items[i][`isNoOfferRound${round}`] = true;
          } else {
            items[i][`offerUnitPriceRound${round}`] = 0;
            items[i][`isNoOfferRound${round}`] = false;
          }

          items[i][`remarkNoOfferRound${round}`] =
            items[i][`remarkNoOfferRound${round}`] === null
              ? ""
              : items[i][`remarkNoOfferRound${round}`];

          items[i].offerUnitPriceRound2 =
            items[i].offerUnitPriceRound2 === null
              ? 0
              : items[i].offerUnitPriceRound2;

          items[i].offerUnitPriceRound3 =
            items[i].offerUnitPriceRound3 === null
              ? 0
              : items[i].offerUnitPriceRound3;

          items[i].offerUnitPriceRound4 =
            items[i].offerUnitPriceRound4 === null
              ? 0
              : items[i].offerUnitPriceRound4;

          items[i].offerUnitPriceRound5 =
            items[i].offerUnitPriceRound5 === null
              ? 0
              : items[i].offerUnitPriceRound5;

          items[i].offerUnitPriceRound6 =
            items[i].offerUnitPriceRound6 === null
              ? 0
              : items[i].offerUnitPriceRound6;
        }
      }
      return items;
    },
    async calculateTotalAmount() {
      for (let i = 0; i < this.projectDetail.length; i++) {
        if (this.projectDetail[i].biddingRound === 1) {
          const total = this.projectDetail[i].item.reduce(
            (sum, transaction) => {
              const sumprice =
                transaction.offerUnitPrice * transaction.quantity;
              return (sum += sumprice);
            },
            0
          );
          this.totalAmount = total * this.projectDetail[i].itemCurrency.rate;
        } else {
          const total = this.projectDetail[i].item.reduce(
            (sum, transaction) => {
              return (sum +=
                transaction[
                  `offerUnitPriceRound${this.projectDetail[i].biddingRound}`
                ] * transaction.quantity);
            },
            0
          );
          this[`totalAmountRound${this.projectDetail[i].biddingRound}`] =
            total * this.projectDetail[i].itemCurrency.rate;
        }
      }
      this.setSubmitBiddingItemModel();
    },
    async getBiddingDetail() {
      var result = await _projectservice.GetBiddingDetail(
        this.$route.params.projectId,
        this.$store.state.AppActiveUser.vendorID
      );
      this.dataBiddingDetail = result[0];
    },
    async importPrice() {
      if (this.fileBulkTemplateImportPrice) {
        const result =
          await _projectservice.GetBiddingProjectVendorSubmitItemNegotiate(
            this.$route.params.projectId,
            this.vendorId
          );

        const round = result.length;

        var form = new FormData();
        form.append("ProjectID", this.$route.params.projectId);
        form.append("VendorID", this.$store.state.AppActiveUser.vendorID);
        form.append("file", this.fileBulkTemplateImportPrice);

        // Set model from read excel to existing model
        if (round <= 1 || round === undefined) {
          var response = await _projectservice.SetModelImportPriceVendor(form);
          const returnSetData = await this.setDataForGetProject(response);
          const r = returnSetData.length - 1;
          if (r > 0) {
            for (let i = 0; i < returnSetData[r].item.length; i++) {
              if (r > 0) {
                this.projectDetail[r].item[i][`offerUnitPriceRound${r + 1}`] =
                  returnSetData[r].item[i][`offerUnitPriceRound${r + 1}`];
                this.projectDetail[r].item[i][`remarkNoOfferRound${r + 1}`] =
                  returnSetData[r].item[i][`remarkNoOfferRound${r + 1}`];
                this.projectDetail[r].item[i][`isNoOfferRound${r + 1}`] =
                  returnSetData[r].item[i][`isNoOfferRound${r + 1}`];
              }
            }
          } else {
            this.projectDetail = returnSetData;
          }
          this.projectDetail[0].biddingRound = 1;
          this.dataBiddingDetailSub = this.setdataBiddingDetial(
            this.projectDetail
          );

          this.isRound =
            this.projectDetail[this.projectDetail.length - 1].biddingRound;
          this.callDetail = true;
        } else {
          var responseNego =
            await _projectservice.SetModelImportPriceVendorNego(form);

          const returnSetData = await this.setDataForGetProject(responseNego);

          this.projectDetail = returnSetData;
          this.dataBiddingDetailSub = this.setdataBiddingDetial(returnSetData);
          this.isRound =
            this.projectDetail[this.projectDetail.length - 1].biddingRound;
          this.callDetail = true;
        }
      }
      this.popupImportPrice = false;
    },
    // Export excel
    async exportToExcel(items) {
      // if (this.propResult.length != 0) {
      this.excelFileName = `OfferPrice`;

      import("../../../services/Export2Excel.js").then((excel) => {
        const list = items;
        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.excelFileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.clearFields();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          // Add col name which needs to be translated
          return v[j];
        })
      );
    },
    clearFields() {
      this.filename = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
    callBackValidateDetail(v) {
      this.validDetail = v;
    },
    async editItemPrice(price, item, round) {
      await this.$nextTick();
      item[round] = price;
    },
  },
  watch: {
    propIsEdit(value) {
      if (value) this.isEdit = value;
    },
    propDataBiddingModelBack(value) {
      if (value) {
        const index = this.projectDetail.length - 1;
        if (this.isRound > 1) {
          for (let i = 0; i < this.projectDetail[index].item.length; i++) {
            const item = this.projectDetail[index].item[i];
            if (
              item[`offerUnitPriceRound${this.isRound}`] !== null ||
              item[`offerUnitPriceRound${this.isRound}`] !== 0
            ) {
              item[`isNoOfferRound${this.isRound}`] = true;
            } else {
              item[`offerUnitPriceRound${this.isRound}`] = 0;
              item[`isNoOfferRound${this.isRound}`] = false;
            }
            if (!item[`offerUnitPriceRound${this.isRound}`])
              item.isNoOffer = true;
            if (!item[`isNoOfferRound${this.isRound}`])
              item[`offerUnitPriceRound${this.isRound}`] = 0;
          }
        } else {
          for (let i = 0; i < this.projectDetail[index].item.length; i++) {
            const item = this.projectDetail[index].item[i];
            if (item.offerUnitPrice !== null || item.offerUnitPrice !== 0) {
              item.isNoOffer = true;
            } else {
              item.offerUnitPrice = 0;
              item.isNoOffer = false;
            }
            if (!item.offerUnitPrice) item.isNoOffer = true;
            if (!item.isNoOffer) item.offerUnitPrice = 0;
          }
        }
      }
    },
    projectDetail: {
      deep: true,
      handler() {
        this.calculateTotalAmount();
      },
    },
    selectedCurrency(newVal) {
      if (newVal) {
        this.$loading(true);
        Promise.all([this.calculateTotalAmount()]).then(() =>
          this.$loading(false)
        );
      }
    },
    propCheckStep(value) {
      if (value === 2) {
        this.validate();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.col {
  padding: 0 0.5rem;
}
</style>
